import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";
const stakeholderRoles = [
  "Decision Maker",
  "Project Manager",
  "Technical Contact",
  "Finance/Billing",
  "Procurement",
  "Legal",
  "General Contact",
];
function ClientContactForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchClientContactData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/client-contacts/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {

        setFormData({
          organization_client_id: data.organization_client_id || "",
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          contact_name: data.contact_name || "",
          designation: data.designation || "",
          stakeholder_role: data.stakeholder_role || "",
          email: data.email || "",
          phone: data.phone || "",
          alternate_phone: data.alternate_phone || "",
          is_primary_contact: data.is_primary_contact || false,
        });

      }
    } catch (error) {
      toast.error("Failed to fetch client data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchClientContactData();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_client_id: "",
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    contact_name: "",
    designation: "",
    stakeholder_role: "",
    email: "",
    phone: "",
    alternate_phone: "",
    is_primary_contact: true
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_client_id) errors.organization_client_id = "Client is required";
    if (!formData.contact_name) errors.contact_name = "Contact name is required";
    if (!formData.designation)
      errors.designation = "Designation is required";

    if (!formData.stakeholder_role)
      errors.stakeholder_role = "Stakeholder role is required";

    // Ensure at least one of email or phone is present
    if (!formData.email && !formData.phone) {
      errors.phone = "Email or Phone is required";
    }

    // Validate email if present
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Enter a valid email";
    }

    // Validate phone if present
    if (formData.phone && !/^[0-9+\-\s]{7,20}$/.test(formData.phone)) {
      errors.phone = "Enter a valid phone number";
    }

    // Validate alternate phone if present
    if (
      formData.alternate_phone &&
      !/^[0-9+\-\s]{7,20}$/.test(formData.alternate_phone)
    ) {
      errors.alternate_phone = "Enter a valid alternate phone number";
    }

    if (formData.alternate_phone && !/^[0-9+\-\s]{7,20}$/.test(formData.alternate_phone)) {
      errors.alternate_phone = "Enter a valid alternate phone number";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const [selectOptions, setSelectOptions] = useState({
    Clients: []
  })
const clients =
  selectOptions?.Clients
    ?.slice()
    ?.sort((a, b) => a.client_name.localeCompare(b.client_name)) || [];
  const fetchClients = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/clients`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response clients is : ", response);

      setSelectOptions((prev) => ({ ...prev, Clients: response.data.data }));
    } catch (e) {
      console.error("Failed to load clients");
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/client-contacts/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Client Contacts updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/client-contacts`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Client Contacts added");
      }

      navigate("/client-contact");
    } catch (err) {
      if (err.response?.status === 422) {
        toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };




  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={" Client Contact"}
        addMessage={"Client Contact"}
        homeLink={"/client-contact"}
        homeText={"Client Contact"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

   
<Autocomplete
  fullWidth
  options={clients}
  getOptionLabel={(option) => option.client_name}
  value={
    clients.find(
      (c) => c.organization_client_id === formData.organization_client_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_client_id: newValue
        ? newValue.organization_client_id
        : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Client Organization Name *"
      error={!!formErrors.organization_client_id}
      helperText={formErrors.organization_client_id}
    />
  )}
/>


                <TextField
                  fullWidth
                  name="contact_name"
                  label="Contact Name *"
                  value={formData.contact_name}
                  onChange={handleChange}
                  error={!!formErrors.contact_name}
                  helperText={formErrors.contact_name}
                />

                <TextField
                  fullWidth
                  name="designation"
                  label="Designation *"
                  value={formData.designation}
                  onChange={handleChange}
                  error={!!formErrors.designation}
                  helperText={formErrors.designation}
                />

          

<Autocomplete
  fullWidth
  options={stakeholderRoles}
  value={formData.stakeholder_role || null}
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      stakeholder_role: newValue || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Stakeholder Role *"
      error={!!formErrors.stakeholder_role}
      helperText={formErrors.stakeholder_role}
    />
  )}
/>


                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_primary_contact"
                        checked={formData.is_primary_contact}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            is_primary_contact: e.target.checked,
                          })
                        }
                      />
                    }
                    label="Is Primary Contact"
                  />
                </FormGroup>

                <TextField
                  fullWidth
                  name="email"
                  label="Email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={!!formErrors.email}
                  helperText={formErrors.email}
                />

                <TextField
                  fullWidth
                  name="phone"
                  label="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  error={!!formErrors.phone}
                  helperText={formErrors.phone}
                />

                <TextField
                  fullWidth
                  name="alternate_phone"
                  label="Alternate Phone "
                  value={formData.alternate_phone}
                  onChange={handleChange}
                  error={!!formErrors.alternate_phone}
                  helperText={formErrors.alternate_phone}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ClientContactForm